<template>
  <section class="footer-container">
    <div class="w1312 footer-top">
      <dl style="min-width:290px;">
        <dt>联系我们</dt>
        <dd>
          <t-tooltip content="商家支持团队-唯商先" theme="light">
            <a :href="`${sessionTarget === 1 ? 'https://store.vip.com/index#/supMpWorkSheet/faultList?tabActive=created' : 'https://vis.vip.com/#/app-v/faultvc/faultHome?queryType=myCreated'}`" target="_blank" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '唯商先' })">唯商先</a>
          </t-tooltip>
        </dd>
      </dl>
      <dl style="max-width:120px;">
        <dt>关注我们</dt>
        <dd>微信公众号：</dd>
      </dl>
      <dl style="max-width:170px;">
        <dt></dt>
        <dd><img :src="ewm1" width="108" height="137"/></dd>
      </dl>
      <dl style="min-width:320px;">
        <dt></dt>
        <dd><img :src="ewm2" width="108" height="137"/></dd>
      </dl>
      <dl>
        <dt>商家APP</dt>
        <dd><img :src="ewm3" width="108" height="137"/></dd>
      </dl>
    </div>
    <div class="w1312 footer-bottom">
      copyright©VIP2023
    </div>
    <div class="feedback-container">
      <a href="https://wj.vip.com/217723?lang=zh-Hans" target="_blank" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '系统反馈' })">
        <img :src="feedback" width="50" height="80" alt="系统反馈" title="系统反馈"/>
      </a>
    </div>
  </section>
</template>

<script>
import ewm1 from '../assets/img/ewm1.png'
import ewm2 from '../assets/img/ewm2.png'
import ewm3 from '../assets/img/ewm3.png'
import feedback from '../assets/img/feedback-pic.png'
import {mapState} from 'vuex'
export default {
  data () {
    return {
      ewm1,
      ewm2,
      ewm3,
      feedback
    }
  },
  computed: {
    ...mapState(['sessionTarget', 'userInfo', 'versions', 'categoryList'])
  }
}
</script>

<style lang="scss" scoped>
.feedback-container {
  position: fixed;
  right: 0;
  bottom: 330px;
  width: 50px;
  height: 80px;
}
.footer-container {
  min-width: 1312px;
  background: #17233D;
  font-size: 12px;
  color: #fff;
  padding: 30px 0 12px;
  a, a:link, a:visited {
    color: #fff;
  }
  .footer-top {
    display: flex;
    dl {
      flex: 1;
      &:first-child {
        margin-left: 140px;
      }
      &:last-child  {
        margin-right: 140px;
      }
      &
      dt {
        width: 100%;
        height: 40px;
      }
    }
  }
  .footer-bottom {
    margin-top: 36px;
    text-align: center;
    color: #999;
  }
}
</style>
